import { useState } from "react";
import { useGT } from "gt-react";
import { Zap } from "lucide-react";
import { usePlanStore } from "../planStore";
import { useAuthStore } from "../authStore";
import { startCheckout } from "../billingClient";
import { toast } from "./Toasts";

export function UpgradeButton() {
  const t = useGT();
  const plan = usePlanStore((s) => s.plan);
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  const [loading, setLoading] = useState(false);

  if (!isAuthenticated || plan !== "free") return null;

  const handleUpgrade = async () => {
    setLoading(true);
    try {
      await startCheckout("personal");
    } catch (error) {
      toast(error instanceof Error ? error.message : t("Failed to start checkout"), "error");
      setLoading(false);
    }
  };

  return (
    <button
      onClick={() => void handleUpgrade()}
      disabled={loading}
      className="flex items-center gap-1 rounded bg-brand px-2 py-1 text-[11px] font-semibold text-zinc-900 hover:bg-brand-light disabled:opacity-50"
      title={t("Start 3-month beta")}
    >
      <Zap size={11} />
      <span>{t("Start Beta")}</span>
    </button>
  );
}
